import React from 'react';

import { Link } from "gatsby"
import { StaticImage } from 'gatsby-plugin-image'

const Footer = () => (
	<footer className="l-footer footer">
		<div className="l-wrap">
			<h2 className="footer__logo">
				<span className="logo__img">
						<StaticImage
							src="../assets/images/logo.png"
							alt="名言アドバイザー MEIGEN ADVISER"
						/>
					</span>
					<span className="logo__text">あなたの人生に名言を。</span>
			</h2>

			<ul className="footer__links">
				{/* <li className="footer__link">
					<Link to="/about">名言アドバイザーとは？</Link>
				</li> */}
				<li className="footer__link">
					<Link to="/privacy">プライバシーポリシー</Link>
				</li>
				{/* <li className="footer__link">
					<Link to="/privacy">免責事項・著作権等</Link>
				</li> */}
				<li className="footer__link">
					<Link to="/contact">お問い合わせ</Link>
				</li>
			</ul>

			<small className="footer__copyright">&copy; Shraddha. All Rights Reserved.</small>
		</div>
	</footer>
)

export default Footer;